import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RpPostpaidBillsComponent } from './rp-postpaid-bills/rp-postpaid-bills.component';

const routes: Routes = [

  { path: 'postpaidBill', component: RpPostpaidBillsComponent },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ConsumerPostpaidRoutingModule { }
